module.exports = Em.View.extend({
    classNames: ['react-view-container']
})
